<template>
    <div>
        <span v-show="hasLabel" class="block text-sm font-medium text-gray-700">{{ label }}<span v-show="$attrs.required || false" class="text-teal font-bold">*</span></span>
        <div class="grid grid-cols-6 gap-3" :class="{
            'mt-1': hasLabel,
        }">
            <div v-for="(code, index) in codes" :key="index" class="col-span-1">
                <input type="text" v-model="codes[index]" :ref="setCodeRef" @input="nextInput($event, index)" @paste="handlePaste($event)" pattern="[0-9]*" inputmode="numeric" class="shadow-sm uppercase focus:ring-teal focus:border-teal block w-full text-2xl border-gray-200 py-4 text-center font-bold text-gray-500 rounded-md" maxlength="1">
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, onBeforeUpdate, onMounted } from 'vue'

export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        modelValue: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }){
        const codes = reactive({
            one: '',
            two: '',
            three: '',
            four: '',
            five: '',
            six: ''
        });

        let codeRefs = [];

        onBeforeUpdate(() => {
            codeRefs = [];
        });

        onMounted(() => {
            codeRefs[0].focus();
        });

        function setCodeRef(el){
            if (el) {
                codeRefs.push(el);
            }
        }

        function nextInput(e, id){
            let index = _.indexOf(Object.keys(codes), id);

            e.target.blur();

            if (index < 5) {
                codeRefs[index+1].focus();
            }

            emit('update:modelValue', (_.values(codes).join('')).toUpperCase());
        }

        function handlePaste(e){
            let dataText = e.clipboardData.getData('text');

            if (dataText != '') {
                for(let i in dataText) {
                    if (i <= 5) {
                        codes[Object.keys(codes)[i]] = dataText[i];
                    }
                }

                emit('update:modelValue', (_.values(codes).join('')).toUpperCase());
            }
        }

        return {
            codes,
            setCodeRef,
            nextInput,
            handlePaste
        }
    },
    computed: {
        hasLabel(){
            return this.label != '';
        },
    }
}
</script>

<style>

</style>
